// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contrast .fixed-action-btn[data-v-93359308],.contrast .fixed-action-btn li[data-v-93359308],.contrast .fixed-action-btn ul[data-v-93359308]{background-color:transparent!important}", ""]);
// Exports
module.exports = exports;
